$.noConflict();
jQuery(document).ready(function($) {
    setTimeout(function() {
        $('#loading').hide();
    }, 800);
    var currentURL = document.URL;
    if (currentURL.indexOf('/search') < 0) {
        clearStorage();
    }

    function popbox() {
        $('#popup-overbox').toggle();
    }
    $("#delCookie").click(function() {
        del_cookie("cookie");
    });
    $('#no-thanks').click(function() {
        popbox().hide('fast');
    });
    $('#popup-close').click(function() {
        popbox().hide('fast');
    });
    $('.ais-facets').on('click', '.facet-hide', function(e) {
        $('.facet-content').toggle();
    });
  
  	 $(".drawer__nav-item").click(function() {
      
	    var current_id = (jQuery(this).attr('id')).replace("Pdiv-","");  
      
        
      if ($(this).hasClass("subviewopen")) {
	        $('#Pdiv-'+current_id+'.drawer__nav-item').removeClass("subviewopen");          	
          	$(".drawer__nav").removeClass("subview");
            $('#Pdiv-'+current_id+" .drawer__nav-item").removeClass("subviewopen");
            $('#Pdiv-'+current_id+' .meganav--drawer').removeClass('meganav--active');
        } else {
	        $('#Pdiv-'+current_id+'.drawer__nav-item').addClass("subviewopen");          	
          	$(this).parents(".drawer__nav").addClass("subview");
            $('#Pdiv-'+current_id+" .drawer__nav-item").addClass("subviewopen");
            $('#Pdiv-'+current_id+' .meganav--drawer').addClass('meganav--active');
            
        }
      jQuery('.drawer__nav-item').each(function(index){      
        var IDD  = (jQuery(this).attr('id')).replace("Pdiv-","");      	
    	if(IDD == current_id)
        {
        }
	      else
      	{
       		
      		$('#Pdiv-'+IDD+'.drawer__nav-item').removeClass("subviewopen");
            $('#Pdiv-'+IDD+" .drawer__nav-item").removeClass("subviewopen");
            $('#Pdiv-'+IDD+' .meganav--drawer').removeClass('meganav--active');   
      	}
    }); 
    });  
  
  
    $(".search-active-btn").click(function() {
        $('.menu-section, .logo-section').css('display', 'none');
        $('.site-header__upper').toggleClass('menu-active');
    });
    $(".cancel-btn").click(function() {
        $('.menu-section, .logo-section').css('display', 'table-cell');
        $('.site-header__upper').toggleClass('menu-active');
    });
    var mainMenuWidth = $('#SiteNav ul.site-nav').width();
    $('ul.meganav__nav').css('width', mainMenuWidth + 'px');
    $("#SiteNav ul.site-nav").hover(function() {}, function() {
        $(this).find("span:last").remove();
    });
    $(document).delegate(".site-nav__link, .meganav__link, .prdtype, .drawer__nav-link", "click", function() {
        clearStorage();
    });
    $("header").delegate(".site-nav__link, .meganav__link", "mousedown", function(event) {
        if (event.which == 2 || event.which == 3)
            clearStorage();
    });
    $(".engagement-wrapper").delegate(".share-design", "click", function() {
        $('.filter-tab,.engagement-products,.engagement-filter').hide();
        var html = '';
        if ($(".custom-bc").find('.cln').length)
            $(".custom-bc").find('.cln').remove();
        html += '<span aria-hidden="true" class="cln">/</span>';
        html += '<a href="javascript:void(0)" class="cln">' + $(this).text() + '</a>';
        $(".custom-bc").append(html);
        localStorage.removeItem("finished");
        localStorage.currenttab = $(this).attr('id');
    });

    function clearStorage() {
        localStorage.removeItem('currenttab');
        localStorage.removeItem("add_cart");
        localStorage.removeItem("selectring");
        localStorage.removeItem("product_title");
        localStorage.removeItem("product_price");
        localStorage.removeItem("product_url");
        localStorage.removeItem("mb_product_title");
        localStorage.removeItem("mb_product_price");
        localStorage.removeItem("mb_product_url");
        localStorage.removeItem("product_sku");
        localStorage.removeItem("product_sku_mb");
        localStorage.removeItem("currentURL");
        localStorage.removeItem("product_data_handle");
        localStorage.removeItem("data_variant_id");
        localStorage.removeItem("product_mb_data_handle");
        localStorage.removeItem("mb_data_variant_id");
        localStorage.removeItem("mb_price");
        localStorage.removeItem("finished");
        if (currentURL.indexOf('/products/') < 0) {
            localStorage.removeItem("cb_path");
            localStorage.removeItem("cln_path");
            localStorage.removeItem("cb_cln_path");
        }
    }
    var visit = getCookie("cookie");
    if (visit == null) {
        popbox();
        var expire = new Date();
        expire = new Date(expire.getTime() + 7776000000);
        document.cookie = "cookie=here; expires=" + expire;
    }

    function del_cookie(name) {
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    function getCookie(c_name) {
        var c_value = document.cookie;
        var c_start = c_value.indexOf(" " + c_name + "=");
        if (c_start == -1) {
            c_start = c_value.indexOf(c_name + "=");
        }
        if (c_start == -1) {
            c_value = null;
        } else {
            c_start = c_value.indexOf("=", c_start) + 1;
            var c_end = c_value.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = c_value.length;
            }
            c_value = unescape(c_value.substring(c_start, c_end));
        }
        return c_value;
    }

    function closest(num, arr) {
        var curr = arr[0];
        var diff = Math.abs(num - curr);
        for (var val = 0; val < arr.length; val++) {
            var newdiff = Math.abs(num - arr[val]);
            if (newdiff < diff) {
                diff = newdiff;
                curr = arr[val];
            }
        }
        return curr;
    }

    function initializePriceRange() {
        wi = $('.price_range-background').width();
        gr = Math.round(wi / 7) - 1;
        $(".price_range-rectangle").draggabilly({
            axis: 'x',
            grid: [gr, gr]
        });
        var prices = ['under', '500', '1500', '5000', '10000', '20000', '40000', 'over']
        var positions = []
        for (i = 0; i < 8; i++) {
            positions.push((gr * i).toString());
        }
        var range = {}
        range[positions[0]] = prices[0];
        range[positions[1]] = prices[1];
        range[positions[2]] = prices[2];
        range[positions[3]] = prices[3];
        range[positions[4]] = prices[4];
        range[positions[5]] = prices[5];
        range[positions[6]] = prices[6];
        range[positions[7]] = prices[7];
        var left_pointer = $('#price_range-pointer-left');
        var right_pointer = $('#price_range-pointer-right');
        $('.price_range-current').css('left', left_pointer.position().left)
        var url_with_price_range = false;
        var original_url = window.location.href.replace(/\/$/, "");
        var current_url = window.location.href;
        var price_param = null;
        var leftovers = null;
        if (original_url.split('/').length == 5) {
            var probably_last_url_segment = original_url.split("/").pop()
            if (($.inArray(probably_last_url_segment.split('-').shift(), prices) != -1) && ($.inArray(probably_last_url_segment.split('-').pop(), prices) != -1)) {
                price_param = original_url.split('/').pop();
            } else {
                leftovers = original_url.split('/').pop();
            }
        } else if (original_url.split('/').length == 6) {
            var probably_last_url_segment = original_url.split("/").slice(0, -1).pop()
            if (($.inArray(probably_last_url_segment.split('-').shift(), prices) != -1) && ($.inArray(probably_last_url_segment.split('-').pop(), prices) != -1)) {
                price_param = probably_last_url_segment;
                leftovers = original_url.split('/').pop();
            } else {
                leftovers = original_url.split('/')[4] + '/' + original_url.split('/')[5];
            }
        } else {}
        var left_position = '';
        var right_position = '';
        if (price_param) {
            left_position = $.inArray(price_param.split('-').shift(), prices);
            right_position = $.inArray(price_param.split('-').pop(), prices)
            url_with_price_range = true;
            left_pointer.css('left', parseInt(positions[left_position]));
            right_pointer.css('left', parseInt(positions[right_position]));
            $('.price_range-current').css('left', parseInt(positions[left_position]) + 7)
            $('.price_range-current').css('right', wi - parseInt(positions[right_position]))
        } else {
            url_with_price_range = false;
            right_pointer.css('left', parseInt(positions[7] - 14));
            $('.price_range-current').css('left', '7px')
            $('.price_range-current').css('right', '7px')
        }
        if (leftovers) {
            leftovers = leftovers.replace('/', '+')
        }
        $('.price_range-rectangle').on('dragEnd', function(event, pointer) {
            var position = $(this).position();
            if ($('#price_range-pointer-left').position().left < $('#price_range-pointer-right').position().left) {
                left_pointer = $('#price_range-pointer-left');
                right_pointer = $('#price_range-pointer-right');
            } else {
                left_pointer = $('#price_range-pointer-right');
                right_pointer = $('#price_range-pointer-left');
            }
            $('.price_range-current').css('left', left_pointer.position().left + 7)
            $('.price_range-current').css('right', wi - right_pointer.position().left)
            var clean_url = '';
            var new_price_range = range[Math.round(closest(left_pointer.position().left, positions))] + '-' + range[Math.round(closest(right_pointer.position().left, positions))];
            var redirect_to = '/collections/' + new_price_range;
            if (leftovers) {
                redirect_to += '/' + leftovers;
                if (new_price_range == 'under-over') {
                    redirect_to = '/collections/' + leftovers;
                }
            } else {
                if (new_price_range == 'under-over') {
                    redirect_to = '/collections';
                }
            }
            location.href = redirect_to;
        })
    }

    function deferFilterjQuery() {
        if ($('.image-product-zoom').length > 0) {
            $('.image-product-zoom').elevateZoom();
        }
        $('body').on('click', '.filter-menu .mobile-header a', function(e) {
            $(".price_range-rectangle").draggabilly('destroy')
            if (e.handled !== true) {
                $('#nav-toggle').toggleClass('active');
                $('.filter-menu .filter-group').not('.has_group_selected').find('h4, ul,.filter-clear').toggle('fast', function() {
                    initializePriceRange();
                });
                e.preventDefault();
                e.handled = true;
            }
        });
    }
    deferFilterjQuery();
    if (document.getElementById("price_range")) {}
    $(window).resize(function() {
        if (document.getElementById("price_range")) {}
        if ($(window).width() > 990) {
            if ($("html").hasClass("js-drawer-open")) {
                $("html, body").removeClass("js-drawer-open js-drawer-open-left");
                $(".page-element").removeClass("is-transitioning");
            }
            $(".site-nav__link ").hover(function() {
                $(this).addClass("meganav--active");
                $(this).parent().find(".site-nav__dropdown").addClass("meganav--active");
            });
        }
        if ($(window).width() < 990) {
            $('.icon-hamburger').click(function() {
                $(".drawer").removeClass("is-transitioning");
            });
            $(".site-nav__link").removeClass("meganav--active");
            $(".meganav").removeClass("meganav--active");
            $(".drawer__nav").removeClass("subview");
            $(".drawer__nav-item").removeClass("subviewopen");
        }
    });
    $(document).delegate(".top-list img", "click", function() {
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    });
    $(window).scroll(function() {
        if ($(this).scrollTop() > 220) {
            $('.top-list img').fadeIn(800);
        } else {
            $('.top-list img').fadeOut(800);
        }
    });
    var type = getParameterByName('type');
    if (type == 'collection') {
        $(window).on('popstate', function(event) {
            location.reload();
        });
    }
    if (type == 'engagement-ring') {
        $(document).delegate('.engagement-products .ais-hits--item', 'click', function() {
            if ($('.collection-tab').hasClass('active')) {
                var handle = $(this).find('.ais-product').attr('data-handle'),
                    variant_id = $(this).find('.ais-product').attr('data-variant-id');
                window.location.href = '/products/' + handle + '?variant=' + variant_id;
            } else {
                $(this).addClass('active');
                loadRingSpecification(this);
            }
        });
    }
    $("#SiteNavLabel-jewelry").click(function(e) {
        window.location = "/collections/all-jewelry";
    });
  
    $("#SiteNavLabel-mens").click(function(e) {
        window.location = "/pages/mens-2019";
    });
  
  	$("#SiteNavLabel-bridal").click(function(e) {
        window.location = "/pages/bridal-landing";
    });

    $("#SiteNavLabel-gifting").click(function(e) {
        window.location = "/pages/gifting";
    });
  	$("#DrawerLabel-bridal").on('click', function(e) {
        window.location = "/pages/bridal-landing";
    });
  
    $("#DrawerLabel-mens").on('click', function(e) {
        window.location = "/pages/mens-2019";
    });

    $("#DrawerLabel-gifting").on('click', function(e) {
        window.location = "/pages/gifting";
    });  
  
  
    if (getParameterByName('type') == 'jewelry') {
        localStorage.cln_path = '';
        localStorage.cb_path = '<a href="/search?type=jewelry-list">Jewelry</a>';
        var jewelItem = getParameterByName("dFR[named_tags.Jewelry][0]");
        if (getParameterByName("dFR[named_tags.Jewelry][0]") != '') {
            localStorage.cb_path += '/ <a href="/search?type=jewelry&dFR[named_tags.Jewelry][0]=' + jewelItem + '">' + jewelItem + '</a>';
            localStorage.cb_cln_path = '/search?type=jewelry&dFR[named_tags.Jewelry][0]=' + jewelItem;
        }
    }
    if (getParameterByName('type') == 'collection') {
        $(".site-nav__item").removeClass("site-nav--active");
        $(".site-nav__item--collection").addClass("site-nav--active");
        localStorage.cln_path = '';
        localStorage.cb_path = '<a href="/search?type=collection">Collection</a>';
        localStorage.cb_cln_path = '/search?type=collection';
    }
    if (getParameterByName('type') == 'engagement-ring') {
        $(".site-nav__item").removeClass("site-nav--active");
        $(".site-nav__item--engagement-ring").addClass("site-nav--active");
    }
});
var currentRingStyle = null,
    currentRingMetal = null,
    currentRingPurity = null,
    currentRingShape = null;
const selectedERStyle = [{
    label: 'Solitaire',
    value: 'Solitaire',
    isRefined: false
}, {
    label: 'Channel Set',
    value: 'Channel Set',
    isRefined: false
}, {
    label: 'Vintage',
    value: 'Vintage',
    isRefined: false
}, {
    label: 'Side Stone',
    value: 'Side Stone',
    isRefined: false
}, {
    label: 'Pave',
    value: 'Pave',
    isRefined: false
}, {
    label: 'Three Stone',
    value: 'Three Stone',
    isRefined: false
}, {
    label: 'Halo',
    value: 'Halo',
    isRefined: false
}, {
    label: 'Tension',
    value: 'Tension',
    isRefined: false
}];
const selectedDiamondCut = [{
    label: 'Round',
    value: 'Round',
    isRefined: false
}, {
    label: 'Princess',
    value: 'Princess',
    isRefined: false
}, {
    label: 'Emerald',
    value: 'Emerald',
    isRefined: false
}, {
    label: 'Oval',
    value: 'Oval',
    isRefined: false
}, {
    label: 'Marquise',
    value: 'Marquise',
    isRefined: false
}];
const selectedMetal = [{
    label: 'Yellow',
    value: 'Yellow',
    isRefined: false
}, {
    label: 'White',
    value: 'White',
    isRefined: false
}, {
    label: 'Rose',
    value: 'Rose',
    isRefined: false
}];
const selectedPurity = [{
    label: 'Platinum',
    value: 'Platinum',
    isRefined: false
}, {
    label: '18K',
    value: '18K',
    isRefined: false
}, {
    label: '14K',
    value: '14K',
    isRefined: false
}];
const metalColor = [{
    label: 'Rose',
    value: 'Rose'
}, {
    label: 'White',
    value: 'White'
}, {
    label: 'Yellow',
    value: 'Yellow'
}, {
    label: 'Platinum',
    value: 'Platinum'
}];

function clearDefaultERFilter() {
    let checkStyle = selectedERStyle.find(o => o.value === currentRingStyle);
    checkStyle.isRefined = false;
    let checkMetal = selectedMetal.find(o => o.value === currentRingMetal);
    checkMetal.isRefined = false;
    let checkPurity = selectedPurity.find(o => o.value === currentRingPurity);
    checkPurity.isRefined = false;
    let checkShape = selectedDiamondCut.find(o => o.value === currentRingShape);
    checkShape.isRefined = false;
    currentRingStyle = null;
    currentRingMetal = null;
    currentRingPurity = null;
    currentRingShape = null;
}

function setDefaultERFilter(helper) {
    helper.setIndex('shopify_products');
    var checkStyle = helper.hasRefinements('named_tags.Er_Style');
    if (!checkStyle) {
        helper.addDisjunctiveFacetRefinement('named_tags.Er_Style', 'Solitaire');
        let checkExist = selectedERStyle.find(o => o.value === 'Solitaire');
        currentRingStyle = 'Solitaire';
        checkExist.isRefined = true;
    } else {
        currentRingStyle = helper.getRefinements('named_tags.Er_Style')[0].value;
        let checkExist = selectedERStyle.find(o => o.value === currentRingStyle);
        checkExist.isRefined = true;
    }
    var checkPurity = helper.hasRefinements('meta.c_f.metal-purity');
    if (!checkPurity) {
        helper.addDisjunctiveFacetRefinement('meta.c_f.metal-purity', '14K');
        let checkExist = selectedPurity.find(o => o.value === '14K');
        currentRingPurity = '14K';
        checkExist.isRefined = true;
    } else {
        currentRingPurity = helper.getRefinements('meta.c_f.metal-purity')[0].value;
        let checkExist = selectedPurity.find(o => o.value === currentRingPurity);
        checkExist.isRefined = true;
    }
    var checkColor = helper.hasRefinements('meta.c_f.gold-color');
    if (!checkColor) {
        helper.addDisjunctiveFacetRefinement('meta.c_f.gold-color', 'White');
        let checkExist = selectedMetal.find(o => o.value === 'White');
        currentRingMetal = 'White';
        checkExist.isRefined = true;
    } else {
        currentRingMetal = helper.getRefinements('meta.c_f.gold-color')[0].value;
        let checkExist = selectedMetal.find(o => o.value === currentRingMetal);
        checkExist.isRefined = true;
    }
    helper.removeFacetRefinement('tags', 'matching-band-available');
    if (!helper.hasRefinements('tags'))
        helper.addFacetRefinement('tags', 'no-matching-band-available');
    var checkShape = helper.hasRefinements('meta.c_f.diamond-cut');
    if (!checkShape) {
        helper.addDisjunctiveFacetRefinement('meta.c_f.diamond-cut', 'Round');
        let checkExist = selectedDiamondCut.find(o => o.value === 'Round');
        currentRingShape = 'Round';
        checkExist.isRefined = true;
    } else {
        currentRingShape = helper.getRefinements('meta.c_f.diamond-cut')[0].value;
        let checkExist = selectedDiamondCut.find(o => o.value === currentRingShape);
        checkExist.isRefined = true;
    }
    if (localStorage.getItem("product_sku") != undefined) {
        helper.removeDisjunctiveFacetRefinement('meta.c_f.sku', localStorage.getItem("product_sku") + 'MB');
    }
}

function reInitSlick() {
    $('.ais-hits').slick('unslick');
}
var clarity_values = ["", "VVS", "VS", "SI", "VVS-VS", "VS-SI"];
var color_values = ["", "E-F", "F-G", "G-H"];

function loadRingSpecification(element) {
    localStorage.removeItem("add_cart");
    localStorage.removeItem("selectring");
    localStorage.removeItem("product_title");
    localStorage.removeItem("product_price");
    localStorage.removeItem("product_url");
    localStorage.removeItem("mb_product_title");
    localStorage.removeItem("mb_product_price");
    localStorage.removeItem("mb_product_url");
    localStorage.removeItem("product_sku");
    localStorage.removeItem("product_sku_mb");
    localStorage.removeItem("product_data_handle");
    localStorage.removeItem("data_variant_id");
    localStorage.removeItem("product_mb_data_handle");
    localStorage.removeItem("mb_data_variant_id");
    localStorage.removeItem("mb_price");
    if ($('.product-images').hasClass('slick-initialized')) {
        $('.product-images').slick('unslick');
    }
    if ($(element).find('.custom-images').text() != '') {
        $('.product-images').html('');
        var images = $(element).find('.custom-images').text().split(','),
            html = '';
        for (var i = 0; i < images.length; i++) {
            if (images[i] != '') {
                var url = "'" + images[i].trim() + "'";
                html += '<div class="ais-hit--picture" style="background-image: url(' + url + ')"></div>';
            }
        }
        $('.product-images').html(html).on('init', function(event, slick) {
            $('.slick-arrow-left').trigger("click");
        });
        $('.product-images').slick({
            lazyLoad: 'ondemand',
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,            
            prevArrow: $('.prev.slick-arrow-left'),
            nextArrow: $('.next.slick-arrow-right')
        });
    }
    if ($(element).find('.custom-meta').text() != '') {
        var html = '<div class="table--columns one-whole">',
            price = '',
            product_title = '',
            product_url = '';
        var metaFields = JSON.parse($(element).find('.custom-meta').text());
        if (metaFields['c_f']['weight'] != undefined && metaFields['c_f']['weight'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Weight</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['weight'][0] + ' grams</div></div>';
        if (metaFields['c_f']['gold-color'] != undefined && metaFields['c_f']['gold-color'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Gold Color</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['gold-color'][0] + '</div></div>';
        if (metaFields['c_f']['material'] != undefined && metaFields['c_f']['material'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Material</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['material'][0] + '</div></div>';
        if ($(element).find('.product-price').text() != '') {
            price = $(element).find('.product-price').text();
            html += '<div class="flex"><div class="display-table-cell one-half">Price</div><div class="display-table-cell one-half text-right">' + price + '</div></div>';
        }
        if (metaFields['c_f']['metal-purity'] != undefined && metaFields['c_f']['metal-purity'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Metal Purity</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['metal-purity'][0] + '</div></div>';
        if ($(element).find('.custom-product').text() != '') {
            var producttype = $(element).find('.custom-product').text();
            html += '<div class="flex"><div class="display-table-cell one-half">Product Type</div><div class="display-table-cell one-half text-right">' + producttype + '</div></div>';
        }
        if (metaFields['c_f']['size'] != undefined && metaFields['c_f']['size'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Ring Size</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['size'][0] + '</div></div>';
        if ($(element).find('.custom-sku').text() != '') {
            var sku = $(element).find('.custom-sku').text();
            html += '<div class="flex"><div class="display-table-cell one-half">SKU</div><div class="display-table-cell one-half text-right">' + sku + '</div></div>';
        }
        html += '</div>';
        $('.ring-specification .display-table').html(html);
        if ($(element).find('.product-title').text() != '') {
            product_title = $(element).find('.product-title').text().trim();
            $('.ring-specification').find('.product-single__title').text(product_title);
        }
        if ($(element).find('.product-url').text() != '') {
            product_url = $(element).find('.product-url').text().trim();
        }
        $('.product-spec').show();
        $('html,body').animate({
            scrollTop: $(".product-spec").offset().top - 50
        }, 'slow');
        var data_handle = $(element).find('.card').attr('data-handle');
        var data_variant_id = $(element).find('.card').attr('data-variant-id');
        if (metaFields['c_f']['sku'] != undefined && metaFields['c_f']['sku'].length) {
            if (localStorage.getItem("product_sku") == undefined)
                localStorage.setItem("product_sku", metaFields['c_f']['sku']);
        }
        if (localStorage.getItem("product_title") == undefined)
            localStorage.setItem("product_title", product_title);
        if (localStorage.getItem("product_price") == undefined)
            localStorage.setItem("product_price", price);
        if (localStorage.getItem("product_url") == undefined)
            localStorage.setItem("product_url", encodeURI(product_url));
        if (localStorage.getItem("product_data_handle") == undefined)
            localStorage.setItem("product_data_handle", data_handle);
        if (localStorage.getItem("data_variant_id") == undefined)
            localStorage.setItem("data_variant_id", data_variant_id);
    }
}

function loadRingBandSpecification(element) {
    if ($(element).find('.matching-bands').text() != '') {
        $('.product-images').html('').slick('unslick');
        var images = $(element).find('.matching-bands').text().split(','),
            html = '';
        var image = encodeURI(images[0].trim());
        for (var i = 0; i < images.length; i++) {
            if (images[i] != '') {
                var url = "'" + images[i].trim() + "'";
                html += '<div class="ais-hit--picture" style="background-image: url(' + url + ')"></div>';
            }
        }
        $('.product-images').html(html).on('init', function(event, slick) {
            $('.slick-arrow-left').trigger("click");
        });
        $('.product-images').slick({
            lazyLoad: 'ondemand',
            dots: true,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: true,
            prevArrow: $('.prev.slick-arrow-left'),
            nextArrow: $('.next.slick-arrow-right')
        });
    }
    if ($(element).find('.custom-meta').text() != '') {
        var html = '<div class="table--columns one-whole">',
            price = '',
            product_title = '',
            product_url = '';
        var metaFields = JSON.parse($(element).find('.custom-meta').text());
        if (metaFields['c_f']['mb-weight'] != undefined && metaFields['c_f']['mb-weight'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Weight</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['mb-weight'][0] + ' grams</div></div>';
        if (metaFields['c_f']['gold-color'] != undefined && metaFields['c_f']['gold-color'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Gold Color</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['gold-color'][0] + '</div></div>';
        if (metaFields['c_f']['mb-material'] != undefined && metaFields['c_f']['mb-material'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Material</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['mb-material'] + '</div></div>';
        var price = 0;
        if (metaFields['c_f']['matching-band-price'] != undefined && metaFields['c_f']['matching-band-price'].length) {
            price = metaFields['c_f']['matching-band-price'];
            html += '<div class="flex"><div class="display-table-cell one-half">Price</div><div class="display-table-cell one-half text-right">$' + metaFields['c_f']['matching-band-price'] + '</div></div>';
        }
        if (metaFields['c_f']['mb-metal-purity'] != undefined && metaFields['c_f']['mb-metal-purity'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Metal Purity</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['mb-metal-purity'] + '</div></div>';
        if ($(element).find('.custom-product').text() != '') {
            var producttype = $(element).find('.custom-product').text();
            html += '<div class="flex"><div class="display-table-cell one-half">Product Type</div><div class="display-table-cell one-half text-right">' + producttype + '</div></div>';
        }
        if (metaFields['c_f']['size'] != undefined && metaFields['c_f']['size'].length)
            html += '<div class="flex"><div class="display-table-cell one-half">Ring Size</div><div class="display-table-cell one-half text-right">' + metaFields['c_f']['size'][0] + '</div></div>';
        if ($(element).find('.custom-sku').text() != '') {
            var sku = $(element).find('.custom-sku').text();
            if (localStorage.getItem("product_sku_mb") == undefined)
                localStorage.setItem("product_sku_mb", sku);
            html += '<div class="flex"><div class="display-table-cell one-half">SKU</div><div class="display-table-cell one-half text-right">' + sku + '</div></div>';
        }
        html += '</div>';
        $('.ring-specification .display-table').html(html);
        var mb_desc = '';
        if (metaFields['c_f']['mb-desc'] != undefined)
            mb_desc = metaFields['c_f']['mb-desc'];
        $('.product-single__description p').text(mb_desc);
        if ($(element).find('.product-title').text() != '') {
            product_title = $(element).find('.product-title').text().trim();
            $('.ring-specification').find('.product-single__title').text(product_title);
        }
        $('.product-spec').find('h1:not(.product-single__title)').hide();
        $('.product-spec').show();
        if ($(element).find('.product-url').text() != '') {
            product_url = $(element).find('.product-url').text().trim();
        }
        var data_handle = $(element).find('.card').attr('data-handle');
        var data_variant_id = $(element).find('.card').attr('data-variant-id');
        if (localStorage.getItem("mb_product_title") == undefined)
            localStorage.setItem("mb_product_title", product_title);
        if (localStorage.getItem("mb_product_price") == undefined)
            localStorage.setItem("mb_product_price", price);
        if (localStorage.getItem("mb_price") == undefined) {
            var mb_price = 0;
            if ($(element).find('.product-price').text() != '')
                mb_price = $(element).find('.product-price').text();
            localStorage.setItem("mb_price", mb_price);
        }
        if (localStorage.getItem("mb_product_url") == undefined)
            localStorage.setItem("mb_product_url", image);
        if (localStorage.getItem("product_mb_data_handle") == undefined)
            localStorage.setItem("product_mb_data_handle", data_handle);
        if (localStorage.getItem("mb_data_variant_id") == undefined)
            localStorage.setItem("mb_data_variant_id", data_variant_id);
    }
    window.scrollTo(0, 250);
}

function redirectToProductSpec() {
    var $this = $('.slick-current .ais-hit'),
        handle = $this.attr('data-handle'),
        variant_id = $this.attr('data-variant-id');
    window.location.href = '/products/' + handle + '?variant=' + variant_id;
}

function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function removeByKey(array, params) {
    array.some(function(item, index) {
        if (array[index][params.key] === params.value) {
            array.splice(index, 1);
            return true;
        }
        return false;
    });
}

function productListView() {
    $('#product-collection-list,#collection-btn,#signature').hide();
    $('.refined-product').show();
    $('#sale').hide();
    $('#gram,#carat,#price-filter').show();
}

/*Mobile sub menu js*/
jQuery(document).ready(function() {
 
  $(".accordion_head").click(function(e) {
    if ($( window ).width()<767 ){ 
    e.stopPropagation();
    var current_id = (jQuery(this).attr('id')).replace("heading-","");   
   
    if ($('#body-'+current_id+'.accordion_body').is(':visible')) {
      $(".accordion_body").slideUp(300);
      $('#heading-'+current_id+" .plusminus").text('+');
    } 
    else{
      $('#body-'+current_id+".accordion_body").slideDown(300);
      $('#heading-'+current_id+" .plusminus").text('-');
    }
    jQuery('.accordion_body').each(function(index){ 
      var chID = jQuery(this).attr('id');
      if(typeof chID !== typeof undefined && chID !== false){
       
        var IDD  = (jQuery(this).attr('id')).replace("body-","");
       	
        if(IDD == current_id)
        {
        }
	      else
      	{
       		$(this).slideUp(300);
      		$('#heading-'+IDD+" .plusminus").text('+');   
      	} 
      }
    	
      });  
    }
  });
});

jQuery(document).ready(function() {
  $("#slimbar_stick_1 .btn_close").click(function(e) {
    $("#NavDrawer").css("margin-top", "0px")  
  });   
});